import { render } from "./uiPageSectionBox.vue?vue&type=template&id=71241298"
import script from "./uiPageSectionBox.vue?vue&type=script&lang=js"
export * from "./uiPageSectionBox.vue?vue&type=script&lang=js"
script.render = render

export default script